import useTranslation from '@/utils/hooks/translation/useTranslation';

import { useRouter } from '@/hooks/utils/useNewRouter';

import { classNames } from '@/utils/classNames';

import type { DashboardType } from '@/types/dashboardType';

import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';

import { DASHBOARD_VIEW } from '@/routes/privateRoutes';

type SuccessModalProps = {
    title?: string;
    notice: string;
    isOpen: boolean;
    toggle: () => void;
    buttonText: string;
    dashboardId?: DashboardType['id'];
};

export const SuccessModal = ({
    title,
    notice,
    isOpen,
    toggle,
    buttonText,
    dashboardId = null
}: SuccessModalProps) => {
    const { t } = useTranslation('dashboard');
    const router = useRouter();

    return (
        <Modal open={isOpen} onDismiss={toggle}>
            <Modal.Body>
                <Modal.Title>{title ?? t('commons:success')}</Modal.Title>
                <Modal.Content>{notice}</Modal.Content>
                <Modal.Footer
                    className={classNames({
                        'justify-center': !dashboardId,
                        'justify-between': dashboardId
                    })}>
                    {dashboardId ? (
                        <button
                            type="button"
                            onClick={toggle}
                            className="font-GSemiBold text-xs text-icoGray-500 underline dark:text-icoDarkMode-wolf">
                            {t('commons:close')}
                        </button>
                    ) : null}
                    <Button
                        onClick={() => {
                            if (dashboardId) {
                                router.push(DASHBOARD_VIEW.replace('[id]', dashboardId.toString()));
                            } else {
                                toggle();
                            }
                        }}>
                        {buttonText}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};
